/* eslint-disable import/prefer-default-export */

import FormatUtils from '../../../utils/FormatUtils';

export const sortDecomptes = (d1, d2) => {
	const datePay1 = FormatUtils.parseDate(d1.datePay)
	const datePay2 = FormatUtils.parseDate(d2.datePay)
	return datePay2 - datePay1
}
